
import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "keen-slider/keen-slider.min.css"
import './styles.css';
import { useKeenSlider } from "keen-slider/react"
import MediumArticlePreview from '../components/MediumArticle.tsx';

import { Drawer, FloatButton } from "antd";
import { MdOutlineWavingHand } from "react-icons/md";
import ContactUs from '../components/contact_form.tsx';

interface Client {
    id: number;
    content: string;
    image: string;
    website: string;
    description: string;
    technologies?: string[];
    languages?: string[];
    sources?: string[];
}

const clients: Client[] = [
    {
        id: 1,
        content: "Chicago Fire",
        image: "chi-logo.png",
        website: "https://www.chicagofirefc.com/",
        description: "Business Strategy and Analytics solutions for Chicago Fire FC.",
        technologies:['snowflake', 'salesforce', 'ticketmaster', 'aws_s3', 'aws_lambda', 'aws_ec2', 'aws_cloudwatch', 'aws_cloudfront', 'aws_route53', 'postgres', 'tableau', 'sigma', 'okta', 'jira', 'github', 'prefect', 'openai'],
        languages: ['python', 'r', 'sql', 'javascript', 'react', 'dbt'],
    },
    {
        id: 2,
        content: "Purveyor Sports",
        image: "purveyor_sports_logo.png",
        website: "https://purveyorsports.com/",
        description: "Sports data infrastructure and autonomous AI for fan growth.",
        technologies:['snowflake', 'aws_s3', 'aws_lambda', 'aws_sagemaker', 'aws_ec2', 'aws_cloudwatch'],
        languages: ['python', 'sql', 'javascript', 'dbt'],
    },
    {
        id: 3,
        content: "Handle Chef",
        image: "handle_log_new.png",
        website: "https://handlechef.com/",
        description: "A Health and Nutrition Data Platform with an AI Assistant.",
        technologies:['snowflake', 'aws_s3', 'aws_lambda', 'aws_ec2', 'aws_cloudwatch'],
        languages: ['python', 'sql', 'javascript', 'dbt'],
    },
    // {
    //     id: 3,
    //     content: "NYT Leaderboards",
    //     image: "leaderboard_logo.png",
    //     website: "https://www.nytleaderboards.com/",
    //     description: "Leaderboard website for NYT games using Django and AWS.",
    //     technologies:['django', 'aws_s3', 'aws_ec2', 'aws_cloudwatch', 'github', 'godaddy'],
    //     languages: ['python'],
    // },
    // {
    //     id: 3,
    //     content: "Revenue Base",
    //     image: "revenuebase.png",
    //     website: "https://revenuebase.ai/",
    //     description: "Data Company specializing in Business Data",
    //     technologies:['snowflake'],
    //     languages: ['python', 'sql'],
    // },
];

//from that list, combine into one list 
const allTechnologies: string[] = [];
const allLanguages: string[] = [];
const allSources: string[] = [];

clients.forEach(client => {
    allTechnologies.push(...(client.technologies || []));
    allLanguages.push(...(client.languages || []));
    allSources.push(...(client.sources || []));
});

//and deduplicate them 
const distinctTechnologies = [...new Set(allTechnologies)];
const distinctLanguages = [...new Set(allLanguages)];
const distinctSources = [...new Set(allSources)];

//randomize their order 
const techBubbles = [
    ...distinctTechnologies.map(tech => ({ type: 'technology', name: tech })),
    ...distinctLanguages.map(lang => ({ type: 'language', name: lang })),
    ...distinctSources.map(source => ({ type: 'source', name: source })),
].sort(() => Math.random() - 0.5);;

//value for the speed of the bubbles moving
const animation = { duration: 30000, easing: (t: number) => t }; // Animation settings


const PortfolioPage: React.FC = () => {

    const [sliderRefSmall] = useKeenSlider<HTMLDivElement>({
        loop: true,
        renderMode: "performance",
        mode: "free",
        drag: true,
        breakpoints: {
            "(min-width: 300px)": { slides: { perView: 2, spacing: .5 } },
            "(min-width: 400px)": { slides: { perView: 3, spacing: 1 } },
            "(min-width: 600px)": { slides: { perView: 5, spacing: 1 } },
            "(min-width: 1000px)": { slides: { perView: 8, spacing: 1 } },
            "(min-width: 1400px)": { slides: { perView: 10, spacing: 1 } },
        },
        slides: {
            origin: 'center',
            perView: 12,
            spacing: 1,
        },
        created(s) {
            s.moveToIdx(-15, true, animation); // Start auto-scroll on creation for small slider
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs - 15, true, animation); // Continue auto-scroll on update
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs - 15, true, animation); // Loop the animation
        },
    });

    
    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//cdn.credly.com/assets/utilities/embed.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const [open, setOpen] = useState(false);

    return (
        <div className="container mt-3">
            {/* Portfolio Header */}
            <div className="text-center row">
                <h1 className="dashboard-title">My Work</h1>
                <p className="dashboard-description">Explore my work across data engineering, sports analytics, and tech consulting.</p>
            </div>

                        {/* Floating Button and Drawer for Contact Form */}
            <FloatButton
                icon={<MdOutlineWavingHand />}
                description="Say Hey!"
                onClick={() => setOpen(true)}
                badge={{ count: 1 }}
                type="default"
                style={{ width: 80, height: 80, position: 'fixed', bottom: 24, right: 24 }}
            />
            <Drawer
                title="Contact Me"
                placement="right"
                onClose={() => setOpen(false)}
                open={open}
                size="large"
            >
                <ContactUs setOpen={setOpen} />
            </Drawer>

            {/* Featured Clients Section */}
            <section className="featured-experience mt-2">
                <h2 className="featured-heading mb-4 text-center">Featured Experience</h2>
                {clients.map(client => {
                    const isGif = client.image.endsWith('.gif');
                    return (
                        <div key={client.id} className={`featured-client featured-client-${client.id}`}>
                            <a href={client.website} className="card p-3 text-center border bg-light mb-2 text-decoration-none">
                                <img src={client.image} alt={client.content} 
                                    className={isGif ? 'invert-gif' : 'card-img-top'}
                                 style={{ height: '150px', objectFit: 'contain' }} />
                                <div className="card-body">
                                    <h5 className="card-title">{client.content}</h5>
                                    <p className="card-text">{client.description}</p>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </section>

            {/* Skills & Technologies */}
            <section className="container my-4">
                <h2 className="mb-4 text-center">Tools I've Used</h2>
                <div ref={sliderRefSmall} className="keen-slider tech-carousel">
                    {techBubbles.map((item, index) => (
                        <div className="keen-slider__slide tech-slide" key={index}>
                            <div className={`tech-circle ${item.type}`}>
                                <span></span>
                                <img src={`externals/${item.name}.png`}  alt={`${item.name} logo`} style={{ width: 'auto', height: '50px' }} />
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Project & Experience Details */}
            <section className="experience-masonry mt-5">
                <h2 className="experience-heading mb-4 text-center">Overview of Projects & Experience</h2>

                {/* Purveyor Sports Project */}
                <div className="col-md-6">
                    <div className="card purveyor-experience-card p-3 border bg-light mb-4">
                        <div className="d-flex align-items-center">
                        <a href="https://purveyorsports.com/" target="_blank" rel="noopener noreferrer">
                            <img
                                src="purveyor_sports_logo.png"
                                alt="Purveyor Sports"
                                style={{ width: '100px', marginRight: '20px', borderRadius: '10px' }}
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Data & AI Engineering</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Purveyor Sports</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>February 2026 - Present</p>
                        </div>
                        </div>
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                            <li>Architect and operate scalable sports data infrastructure using <strong>Snowflake</strong>, <strong>dbt</strong>, <strong>Prefect</strong>, <strong>AWS</strong>, and <strong>Sigma</strong>, orchestrating millions of rows of ticketing, CRM, marketing, merchandise, digital engagement, and behavioral data across disparate source systems.</li>
                            <li>Build a robust <strong>identity graph and golden-record architecture</strong> that resolves fragmented customer identities across systems into persistent fan profiles, creating a trusted, unified data layer for analytics, segmentation, machine learning, and activation.</li>
                            <li>Build <strong>Sixth Man</strong>, an autonomous AI revenue agent using <strong>LangChain</strong>, <strong>LangGraph</strong>, <strong>Amazon Bedrock</strong>, <strong>Snowflake Cortex</strong>, and the <strong>OpenAI API</strong> on top of golden-record customer data to identify revenue opportunities and autonomously generate highly personalized fan outreach.</li>
                            <li>Develop stateful, multi-touch agent workflows that continuously incorporate ticketing history, email engagement, digital behavior, prior outreach, purchases, and fan responses—allowing <strong>Sixth Man</strong> to maintain an evolving understanding of each fan and seamlessly coordinate personalized campaigns across the customer lifecycle.</li>
                            <li>Develop production <strong>computer vision and data engineering workflows</strong> with <strong>Momento</strong>, using <strong>YOLOv8</strong> and <strong>MiVOLO</strong> to detect, classify, and transform stadium imagery into structured fan behavioral and demographic datasets.</li>
                            <li>Partner with <strong><a href="https://www.mymomento.com/" target="_blank" rel="noopener noreferrer">Momento</a></strong> and <strong><a href="https://www.venuevision.org/" target="_blank" rel="noopener noreferrer">Venue Vision</a></strong> to connect fan data, venue intelligence, and dynamic experiences for sports properties.</li>
                        </ul>
                        <div className="purveyor-article mt-4">
                            <MediumArticlePreview
                                title="Momento Launches New Fan Data Platform with Venue Vision"
                                link="https://www.sportsbusinessjournal.com/Articles/2026/09/02/momento-launches-new-fan-data-platform-venue-vision/"
                                description="Sports Business Journal covers how Momento and Venue Vision are bringing fan data and venue intelligence together to create more dynamic, personalized experiences for sports properties."
                                image="purveyor_sports_logo.png"
                            />
                        </div>
                    </div>
                </div>

                {/* Chicago Fire Project 1*/}
                <div className="col-md-6">
                    <div className="card p-3 border bg-light mb-4">
                        {/* Top Row: Image and Text */}
                        <div className="d-flex align-items-center">
                        <a href="https://chicagofirefc.com" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="chi-logo.png" 
                                alt="Chicago Fire FC" 
                                style={{ width: '90px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Sr. Manager, Business Strategy and Analytics</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Chicago Fire FC</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>March 2025 - February 2026</p>
                        </div>
                        </div>

                        {/* Bullet Points */}
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                            <li>Redefined the Business Strategy org from reactive support to a <strong>proactive, data science–driven function</strong>; managed & coached a data analyst, data scientist, and CRM admin to align analytics with revenue and engagement outcomes.</li>
                            <li>Drove season ticket retention using <strong>predictive modeling</strong> that forecasted renewal revenue within 11% and improved individual churn-risk accuracy by 20%, influencing rep focus and leadership decisions.</li>
                            <li>Led organization-wide <strong>AI & LLM adoption</strong> via an OpenAI pilot with C-suite & VPs; deployed fine-tuned models that saved 3+ hours per brief, improved brand alignment by 12%, and cut 5+ hours from proposal creation.</li>
                            <li>Directed GTM enablement for the new stadium; selected, negotiated, and deployed <strong>Conversica AI</strong> to pre-qualify leads, generating <strong>$300K+ incremental revenue</strong> with a 4× ROI.</li>

                        </ul>


                        {/* Related Medium Article */}
                        <div className="mt-4">
                        <MediumArticlePreview
                            title="Using Event-Level Data to Make Hyper-Personalized LLMs"
                            link="https://medium.com/@seanpjk/using-event-level-data-to-make-hyper-personalized-llms-part-1-8ff681eed0bf"
                            description="This article is a thought exploration on how to convert event-driven data and make it very usable to LLMs. Then, I go into a few of the projects I have been working on around this idea."
                            image="https://miro.medium.com/v2/resize:fit:720/format:webp/1*9JgFVQzxMtPM__XY4rJzXw.png"
                        />
                        </div>
                    </div>

                    {/* Chicago Fire Project 2*/}
                    <div className="card p-3 border bg-light mb-4">
                        {/* Top Row: Image and Text */}
                        <div className="d-flex align-items-center">
                        <a href="https://chicagofirefc.com" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="chi-logo.png" 
                                alt="Chicago Fire FC" 
                                style={{ width: '90px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Full Stack Data Engineer</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Chicago Fire FC</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>January 2022 - March 2025</p>
                        </div>
                        </div>

                        {/* Bullet Points */}
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                            <li>Built a <strong>front-office portal</strong> using React (frontend) and Django (backend).</li>
                            <li>Developed a <strong>middleware API</strong> to connect the portal to Snowflake.</li>
                            <li>Served the portal using <strong>AWS (CloudWatch, Route 53, S3, EC2)</strong> with Nginx for backend hosting.</li>
                            <li>Fine-tuned <strong>OpenAI models</strong> for email generation, article summarization, and text-to-SQL conversion.</li>
                            <li>Used <strong>Docker, Prefect, ECR, EC2, and Kubernetes</strong> for automated ingestion of all business-side club data.</li>
                            <li>Owned and administered <strong>data warehouse + data engineering + application development</strong> initiatives.</li>

                        </ul>

                        {/* Related Medium Article */}
                        <div className="mt-4">
                        <MediumArticlePreview
                            title="Building a Sovereign Tech Stack in Sports"
                            link="https://medium.com/@seanpjk/building-a-sovereign-tech-stack-in-sports-f7b0f609e8fb"
                            description="This article goes more in depth on what solutions we use in our tech stack, why we went about choosing them, and some of the benefits we obtained in doing so. It is always an ongoing process, but this is how we arrived at the current state."
                            image="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*b4Wq_gcjvdZXNJWeE6ksNg.png"
                        />
                        </div>
                    </div>

                </div>

                
                <div className="col-md-6">
                    {/* handle chef */}
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        <div className="card p-3 border bg-light mb-4">
                        {/* Top Row: Image and Headers */}
                        <div className="d-flex">
                            <a href="https://handlechef.com" target="_blank" rel="noopener noreferrer">
                                <img
                                src="handle_log_new.png"
                                alt="Handle Chef Logo"
                                style={{
                                    width: '70px',
                                    marginRight: '20px',
                                    borderRadius: '10px',
                                }}
                                />
                            </a>
                            <div>
                            <h3 style={{ margin: 0 }}>Handle Chef</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>
                                handlechef.com
                            </p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>
                                November 2024 - Present
                            </p>
                            </div>
                        </div>

                        {/* Bullet Points */}
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                            <li>Built a responsive web app using <strong>React</strong> on <strong>Vercel</strong> with serverless functions.</li>
                            <li>Designed a normalized backend data model on <strong>Supabase</strong> for health data, food nutrition, and pricing.</li>
                            <li>Integrated <strong>WHOOP</strong> and <strong>Google OAuth</strong> for seamless user authentication.</li>
                            <li>Implemented food tracking using nutritional data from the <strong><a href="https://world.openfoodfacts.org/" target="_blank" rel="noreferrer">World Open Food Facts API</a></strong>.</li>
                            <li>Developed an <strong>emotion logging</strong> feature that syncs with user health metrics for holistic daily analysis.</li>
                            <li>Integrated the <strong>OpenAI API</strong> to generate daily summaries and personalized recommendations from user behavior.</li>

                        </ul>
                        </div>
                    </div>

                    {/* handle social */}
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        <div className="card p-3 border bg-light mb-4">
                            {/* Top Row: Logo and Headers */}
                            <div className="d-flex">
                            <a
                                href="https://handle-social.vercel.app/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex align-items-center"
                                aria-label="Open Handle Social"
                                title="Open Handle Social"
                                style={{ textDecoration: 'none' }}
                            >
                                {/* Inline SVG logo using your path (Heroicons-style) */}
                                <div
                                style={{
                                    width: 70,
                                    height: 70,
                                    marginRight: 20,
                                    borderRadius: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#f2f3f5',
                                }}
                                >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    role="img"
                                    aria-label="Handle Social Logo"
                                    style={{ width: 40, height: 40, color: '#0468d3ff' /* neutral-900 */ }}
                                >
                                    <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                </div>
                            </a>

                            <div>
                                <h3 style={{ margin: 0 }}>Handle Social</h3>
                                <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>
                                handle-social.vercel.app &nbsp;•&nbsp;{' '}
                                <a
                                    href="https://github.com/sean-kearns/HandleSocial"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    GitHub
                                </a>
                                </p>
                                <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>
                                October 2025 – Present 
                                </p> 
                            </div>
                            </div>

                            {/* Bullet Points */}
                            <ul style={{ marginTop: 10, paddingLeft: 20 }}>
                            <li>
                                Centralizes social handles; <strong>verifies ownership</strong> to boost data value.
                            </li>
                            <li>
                                <strong>Marketplace</strong> shows indicative data rates by platform and verification status.
                            </li>
                            <li>
                                <strong>Brands request access</strong> to verified datapoints; designed so payouts flow directly to users
                                (simulated in concept).
                            </li>
                            <li>
                                <strong>Verifiability Score</strong> incentivizes accurate linking and increases potential earnings.
                            </li>
                            <li>
                                <strong>Brand View</strong> previews cross-platform audience insights and ecosystem breakdowns.
                            </li>
                            </ul>
                        </div>
                    </div>


                    {/* NYT Leaderboards Project */}
                    <div className="card p-3 border bg-light mb-4">
                        {/* Top Row: Image and Text */}
                        <div className="d-flex align-items-center">
                        <a href="https://nytleaderboards.com" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="leaderboard_logo.png" 
                                alt="NYT Leaderboards" 
                                style={{ width: '100px', marginRight: '20px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>NYT Connections Leaderboard</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>nytleaderboards.com</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Feb 2024 - Present</p>
                        </div>
                        </div>

                        {/* Bullet Points */}
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Built a leaderboard site for NYT Connections scores using Django.</li>
                        <li>Implemented OAuth 2.0 and Google Analytics to improve user expereince.</li>
                        <li>Deployed on AWS EC2 with Nginx and Gunicorn.</li>
                        </ul>

                        {/* Related Medium Article */}
                        <div className="mt-4">
                        <MediumArticlePreview
                            title="How Staying Up All Night Coding Can Make Your Friends Happy"
                            link="https://medium.com/@seanpjk/how-staying-up-all-night-coding-can-make-your-friends-happy-a19ca0399c39"
                            description="This article tells the story of why we needed to make a leaderboard for our friends, and how we went about doing so."
                            image="https://miro.medium.com/v2/resize:fit:1400/format:webp/0*hYvkvGYEyZ3ySmoc"
                        />
                        </div>
                    </div>

                    {/* SpikeHat Games Project */}
                    <div className="card p-3 border bg-light mb-4">
                        <div className="d-flex align-items-center">
                        <a href="https://spike-hat-games.vercel.app/" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="sh_logo_new.png" 
                                alt="SpikeHat Logo" 
                                style={{ width: '80px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Engineering Consultant</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>SpikeHat Games</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>September 2025 - Present</p>
                        </div>
                        </div>
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Beginning work with an up-and-coming board game company on digital strategy.</li>
                        <li>Designed and built their website comprised of game pages and blog posts.</li>
                        <li>Assisting in GTM strategy and integrated payments.</li>
                        </ul>
                    </div>

                    {/* Revenue Base Project */}
                    <div className="card p-3 border bg-light mb-4">
                        <div className="d-flex align-items-center">
                        <a href="https://revenuebase.ai/" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="revenuebase_small.png" 
                                alt="Revenue Base" 
                                style={{ width: '80px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Engineering Consultant</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Revenue Base</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>October 2024 - February 2025</p>
                        </div>
                        </div>
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Developed data pipelines in Domo to create rich visualizations and dashboards to report on deal metrics, lead growth, renewal health.</li>
                        </ul>
                    </div>

                    {/* Dyer Brothers Sealcoating Project */}
                    <div className="card p-3 border bg-light mb-4">
                        <div className="d-flex align-items-center">
                        <a href="https://www.dyerbrotherssealcoating.com/" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="dyer_bros_no_bg.png" 
                                alt="Dyer Brothers Sealcoating" 
                                style={{ width: '100px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Engineering Consultant</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Dyer Brothers Sealcoating</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>July 2023 - February 2024</p>
                        </div>
                        </div>
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Migrated CRM to Hubspot, increasing efficiency of business processes and cleanliness of data.</li>
                        <li>Utilized AWS Pinpoint for cost-effective phone number analysis.</li>
                        <li>Took wesbite in-house, deploying with Vercel resulting in dramatic cost savings.</li>
                        </ul>
                    </div>

                    {/* Hale Project */}
                    <div className="card p-3 border bg-light mb-4">
                        <div className="d-flex align-items-center">
                        <a href="https://thehale.co" target="_blank" rel="noopener noreferrer">
                            <img 
                                src="hale.png" 
                                alt="Hale" 
                                style={{ width: '80px', marginRight: '20px', borderRadius: '10px' }} 
                            />
                        </a>
                        <div>
                            <h3 style={{ margin: 0 }}>Advisor</h3>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>Hale</p>
                            <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>February 2025 - June 2025</p>
                        </div>
                        </div>
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Advisor to Hale, a product recommendation service to allow men to be exposed to new, beneficial products.</li>
                        <li>Assist in deploying to Firebase, establishing clear CI/CD processes for developing on a remote team.</li>
                        <li>Developed database using Supabase and customer tracking with Mixpanel to get a comprehensive view of Users and Products and how they interact.</li>
                        </ul>
                    </div>
                    
                </div>
            </section>

        </div>

        
    );
};

export default PortfolioPage;


                        // <div
                        // style={{
                        //     position: 'absolute',
                        //     top: '120px',
                        //     left: '0',
                        //     right: '0',
                        //     backgroundColor: 'rgba(255, 0, 0, 0.6)', // Semi-transparent red
                        //     color: 'white',
                        //     textAlign: 'center',
                        //     fontSize: '1.5rem',
                        //     fontWeight: 'bold',
                        //     padding: '10px 0',
                        //     transform: 'rotate(-10deg)', // Optional diagonal stripe effect
                        //     zIndex: 10,
                        // }}
                        // >
                        // COMING SOON
                        // </div>